// extracted by mini-css-extract-plugin
export default {"InfoLabel":"InfosLabels_InfoLabel__Ce--5","Green":"InfosLabels_Green__IweL2"};